import getStore from '../store';
import type { SearchFilterOption } from 'owa-timestream-asset-search';
import type { ObservableMap } from 'mobx';

export function searchFilters(): ObservableMap<string, SearchFilterOption> {
    const store = getStore();
    return store.searchFilters;
}

export function searchFilter(key: string): SearchFilterOption {
    const store = getStore();
    return store.searchFilters.get(key);
}
